import classnames from 'classnames';
import React from 'react';

export function Button({
  className, buttonLook = "default", type = "button",
  size, component, ...props
}) {
  const btnClass = classnames("btn",
                              "btn-"+buttonLook,
                              size ? "btn-"+size : null,
                              className
  );
  const isLink = component == "a";
  const Component = isLink ? "a" : "button";
  return <Component type={isLink ? undefined : type} className={btnClass} {...props}>{props.children || props.text}</Component>;
}

export default Button;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/Button.jsx